import { ThemeEvents, CartUpdateEvent } from '@theme/events';

// if locale is GB, show a motivator bar
// motivator bar should count up to £50 = 100%

//alert("hello from motivator!");
//console.log("hello from motivator with country_code "+country_code+"!");

var enable_custom_motivator = true;
//var enable_custom_motivator = false;
var free_shipping_at = 5000;    // in pence!
var percent_complete = 0;

//alert("hello " + country_code);

if (country_code == 'GB' && enable_custom_motivator) {
    //console.log("3dt-motivator.js: country_code is GB, enabling motivator bar!");

    //alert("hello there GB");
    function refresh_motivator() {
        //console.log("3dt-motivator.js: refresh_motivator called!");
        $.ajax({
            type: 'GET',
            url: '/cart.json', //routes.cart_url,
            cache: false,
            dataType: 'json',
            success: function(cart) {
                //console.log("cart-3dt!");
                //console.log("3dt-motivator.js: cart callback received!");
                do_motivator_bar(cart);
                // whatever you want to do with the cart obj
            }
        }); 
    }

    var bar1;
    
    function update_motivator_bar(cart) {
        //console.log("3dt-motivator.js: update_motivator_bar!");

        percent_complete = (cart.total_price/free_shipping_at) * 100;
        bar1.style.setProperty('--pss-value', percent_complete);

        // update the text inside the bar
        if (percent_complete==0) {
            document.getElementById('motivator_bar').innerText = "Cart empty";
        } else if (percent_complete>=100) {
            document.getElementById('motivator_bar').innerText = "Free UK shipping unlocked!";
        } else {
            document.getElementById('motivator_bar').innerText = "";
        }

        // update the message above the bar
        if (percent_complete>=100) {
            document.getElementById('motivator_bar_message').innerText = 'Free UK shipping unlocked!';
        } else {
            document.getElementById('motivator_bar_message').innerText = 'Add £'+ ((5000-cart.total_price)/100).toFixed(2) + ' more to your cart to get FREE TRACKED SHIPPING to UK addresses!';
        }
    }

    function do_motivator_bar(cart) {
        //console.log("3dt-motivator.js: do_motivator_bar..");
        if(document.getElementById('motivator_bar_disabled') != undefined) {
            console.log("motivator_bar_disabled element found, not showing motivator bar!");
            return;
        }

        percent_complete = (cart.total_price/free_shipping_at) * 100;

        bar1 = document.getElementById('motivator_bar');
        //console.log("do_motivator_bar: about to s0et bar1 to " + percent_complete);
        document.getElementById('motivator_bar_host').style.display = 'block';

        update_motivator_bar(cart);
    }

    var currentPageLink = window.location.href;
    
    // list of page URLs where the motivator bar should not be shown
    // todo: probably don't need to worry about this now, since the bar is only shown within announcement bar
    var should_show = !(
        currentPageLink.includes('/pages/') || 
        currentPageLink.includes('/policies/') || 
        currentPageLink.includes('/blogs/') || 
        currentPageLink.includes('/tools') || 
        currentPageLink.includes('/account') ||
        currentPageLink.includes('auction')
    );
    if (should_show) {
        //console.log("3dt-motivator.js: page link '" + currentPageLink + "' allowed, showing motivator bar!");
        refresh_motivator();
        document.addEventListener(ThemeEvents.cartUpdate, refresh_motivator);
    } else {
        //console.log("3dt-motivator.js: page link '" + currentPageLink + "' doesn't match allowed pages");
        document.getElementById('motivator_bar_host')?.remove();
    }
} else {
    // delete the motivator bar from the DOM if we aren't in the right country
    //console.log("3dt-motivator.js: country_code is not GB, removing motivator bar!");
    document.getElementById('motivator_bar_host')?.remove();
}
